function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#2B9D8B",
  width: 24,
  height: 24,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8.726a3.276 3.276 0 1 0 0 6.552 3.276 3.276 0 0 0 0-6.552zm7.313 2.455a7.358 7.358 0 0 0-6.496-6.495V3H11.18v1.686a7.358 7.358 0 0 0-6.495 6.495H3v1.638h1.686a7.358 7.358 0 0 0 6.495 6.495V21h1.638v-1.687a7.358 7.358 0 0 0 6.495-6.496H21V11.18l-1.687.002zm-13.04.818a5.726 5.726 0 1 1 11.453 0 5.726 5.726 0 0 1-11.453 0z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgAutoDetectLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDetectLocation);
export default __webpack_public_path__ + "static/media/auto_detect_location.bbff25ba.svg";
export { ForwardRef as ReactComponent };